










































































import { Component, Vue } from 'vue-property-decorator';
import * as amplitude from 'amplitude-js';
import {
  ItemDTO, LookFullDTO, CatalogItemShortDTO,
} from '@/api';
import EditingLayout from '@/layouts/EditingLayout.vue';
import VImage from '@/components/common/VImage.vue';
import { clientsModule, looksModule, sandboxModule } from '@/store';
import LooksItem from '@/components/looks/LooksItem.vue';
import CheckCard from '@/components/common/CheckCard.vue';
import LookActionsCard from '@/components/looks/LookActionsCard.vue';
import { Route } from 'vue-router';
import { getAssetUrl } from '@/utils';

@Component({
  name: 'sandbox-looks-edit-page',
  components: {
    EditingLayout,
    LooksItem,
    LookActionsCard,
    VImage,
    CheckCard,
  },
})
export default class Catalog extends Vue {
  get client() {
    return clientsModule.model;
  }

  get looks() {
    return looksModule.groupedThingsByLook;
  }

  get look() {
    return looksModule.selectedLook;
  }

  get things() {
    return sandboxModule.things;
  }

  get lookThings() {
    return this.look && this.look.items ? this.look.items : [];
  }

  get selectedThings() {
    return this.lookThings.map(thing => thing.clientItemId);
  }

  get selectedCatalogThings() {
    return this.lookThings.map(thing => thing.catalogItemId);
  }

  get categories() {
    return sandboxModule.userThingsCategories;
  }

  get thingsSandbox() {
    return sandboxModule.sandboxThings;
  }

  get groupByCategory() {
    return sandboxModule.groupByCategory;
  }

  get loadingThing() {
    return looksModule.loadingThing;
  }

  created() {
    amplitude.getInstance().logEvent('Страница редактирование луков в песочнице', { clientId: this.client && this.client.id });
    if (this.client && this.client.id != null) {
      looksModule.fetchLooks({ userId: this.client.id, status: 'SANDBOX' }).then(() => {
        if (this.$route.query.selected) {
          looksModule.setSelected([Number(this.$route.query.selected)]);
          this.$nextTick().then(() => {
            this.scrollIntoView(Number(this.$route.query.selected));
          });
        }
      });
      sandboxModule.fetchThings(this.client.id);
      if (this.client?.id != null) {
        looksModule.fetchCategories(this.client.id);
      }
    }
  }

  beforeRouteUpdate(to: Route, from: Route, next: () => void) {
    looksModule.setSelected([Number(to.query.selected)]);
    next();
  }

  selectLook(id: number) {
    if (id !== Number(this.$route.query.selected)) {
      this.$router.push({ query: { selected: String(id) } });
    }
  }

  scrollIntoView(id: number) {
    if (Array.isArray(this.$refs.actionCards)) {
      const element = this.$refs.actionCards[this.looks.findIndex(look => look.id === id)];
      if (!(element instanceof Element)) {
        element.$el.scrollIntoView({ block: 'center' });
      }
    }
  }

  async addLook() {
    const category = looksModule.categories.find(c => c.translation === 'Рекомендовано стилистом');
    if (category && category.category != null && this.client?.id != null) {
      const { id } = await looksModule.saveLook({
        look: {
          category: category.category,
          name: '',
        },
        userId: this.client?.id,
        status: 'SANDBOX',
      });
      if (id != null) {
        this.selectLook(id);
      }
    }
  }

  async copyLook(look: LookFullDTO) {
    const { id } = await looksModule.copyLook(look);
    if (id) {
      this.selectLook(id);
      this.scrollIntoView(id);
    }
  }

  removeLook(id: number) {
    this.$confirm('Вы уверены, что хотите удалить данный образ?', 'Внимание!', {
      confirmButtonText: 'Удалить',
      cancelButtonText: 'Отмена',
      type: 'warning',
    }).then(() => {
      looksModule.deleteLook([id]);
      this.$message({
        type: 'success',
        message: 'Образ удалён',
      });
    });
  }

  addLookThing(thing: ItemDTO) {
    if (this.look && this.look.id != null && !this.loadingThing) {
      looksModule.saveLookThing({ lookId: this.look.id, thing });
    }
  }

  addLookCatalogThing(thing: CatalogItemShortDTO) {
    if (this.look && this.look.id != null && !this.loadingThing) {
      looksModule.saveLookCatalogThing({ lookId: this.look.id, thing });
    }
  }

  removeLookThing(thing: ItemDTO) {
    if (this.look && this.look.id != null && thing.id && !this.loadingThing) {
      looksModule.deleteLookThing({ lookId: this.look.id, thingId: thing.id });
    }
  }

  removeLookCatalogThing(thing: CatalogItemShortDTO) {
    if (this.look && this.look.id != null && thing.id != null) {
      looksModule.deleteLookCatalogThing({ lookId: this.look.id, thingId: thing.id });
    }
  }

  isThingSelected(id: number) {
    return this.selectedThings.includes(id);
  }

  isCatalogThingSelected(id: number) {
    return this.selectedCatalogThings.includes(id);
  }

  thingImg(item: ItemDTO & CatalogItemShortDTO) {
    if (item.pictUrl) {
      return getAssetUrl(item.pictUrl);
    }
    return item.fileNames && item.fileNames.length ? item.fileNames[0].fileName : null;
  }
}
